export interface IEqualityCheckPrintPreviewTableData {
    isMappingAssetsAndLiabilitiesConsistent: boolean;
    isMappingProfitIncomeAndProfitFliConsistent: boolean;
    isCashflowStatementTotalsConsistent?: boolean;
    isAdjustmentsAssetsAndLiabilitiesConsistent?: boolean;
    isAdjustmentsProfitIncomeAndProfitFliConsistent?: boolean;
    // REV-20899: Reclassifications are always balanced by construction (transactional double-entry model).
    // `isReclassesAssetsAndLiabilitiesConsistent` and `isReclassesProfitIncomeAndProfitFliConsistent` removed.
}
